import isArray from 'lodash/isArray'
import queryString from 'query-string'

export const LOGIN_REDIRECT_QUERY_PARAM = 'redirect'
export const OAUTH_REDIRECT_QUERY_PARAM = 'redirect_url'

type LocationParts = {
  pathname: string
  search?: string
  hash?: string
}

const firstString = (value: unknown): string => {
  if (isArray(value)) return String(value[0] || '')
  return typeof value === 'string' ? value : ''
}

export const getQueryRedirect = (
  search = window.location.search,
  param: typeof LOGIN_REDIRECT_QUERY_PARAM | typeof OAUTH_REDIRECT_QUERY_PARAM,
): string => firstString(queryString.parse(search)[param])

export const getLoginRedirectFromSearch = (
  search = window.location.search,
): string =>
  getQueryRedirect(search, OAUTH_REDIRECT_QUERY_PARAM) ||
  getQueryRedirect(search, LOGIN_REDIRECT_QUERY_PARAM)

export const buildCurrentPathRedirect = ({
  pathname,
  search = '',
  hash = '',
}: LocationParts): string => `${pathname}${search}${hash}`

export const buildLoginUrlWithRedirect = (redirect: string): string =>
  `/login?${LOGIN_REDIRECT_QUERY_PARAM}=${encodeURIComponent(redirect)}`

export const appendOAuthStateRedirect = (
  state: string,
  redirect: string,
): string =>
  redirect
    ? `${state}${OAUTH_REDIRECT_QUERY_PARAM}=${encodeURIComponent(redirect)}`
    : state

export const isSafeInternalRedirect = (redirect: string): boolean =>
  redirect.startsWith('/') &&
  !redirect.startsWith('//') &&
  !redirect.startsWith('/\\')

export const getSafeInternalRedirect = (
  redirect: string,
  fallback: string,
): string => (isSafeInternalRedirect(redirect) ? redirect : fallback)
